
import React from 'react'
import { aboutBottomImg, beliefArr, brigadeTechPark, call1Img, flowActionArr, fprojectBannerData, industrySectionArr, mobile, teamArr } from '../constants/AppConstant'
import CountUp from 'react-countup';
import { Link } from 'react-router-dom';
import { FaLinkedin } from "react-icons/fa";
import { CiLinkedin } from "react-icons/ci";

function About() {

  function openLinkedin(v){
    window.open(v,'_blank')
  }
  return (
    <div className='relative'>
        <div className='relative flex items-center justify-center bg-about_bg1 bg-center bg-cover h-[200px]  md:h-[340px] 2xl:h-[500px]'>
            <div className='z-10'>
              <h6 className='text-[30px] text-white text-center tracking-[10px] font_thicker opacity-80 2xl:text-[35px]'>About Us</h6>
              <h6 className='text-center font_normal text-white opacity-100  text-[14px] 2xl:text-[18px]'> <span onClick={()=>navigator('/')} className='relative cursor-pointer after:bg-[#fff] after:absolute after:h-[2px] after:w-0 after:bottom-0 after:left-0  text-white opacity-100  hover:after:w-full after:transition-all after:duration-300'>Home</span> / About Us </h6>
              <h6 className='text-[13px] mt-1  text-white text-center font_normal 2xl:text-[16px] opacity-80'>Would you like to know more about us?. We would love to introduce ourselves. </h6>
            </div>
            <div className='bg-black opacity-60 absolute top-0 left-0 w-full h-[200px]  md:h-[340px] 2xl:h-[500px]'>
            </div> 
        </div>


        <div className='w-[90%] md:w-[80%]  py-[2%] md:flex items-center mx-auto'>

          <img src={fprojectBannerData} className='md:w-[50%] object-contain md:h-[400px] 2xl:h-[500px]' />

          <div className='md:w-[50%] md:ml-10'>
          
            <h6 className='font_bold text-center md:text-left text-[20px] 2xl:text-[25px] mt-2'>About Us</h6>
            <div className='flex items-center justify-center md:justify-start'>
              <h6 data-aos="fade-right" className='w-[50px] border-b-[2px] rounded-[10px] border-[#027d9b]'></h6>
              <h6 data-aos="fade-up" data-aos-delay="300" className='text-[10px] font_bold text-[#027d9b] 2xl:text-[15px] mx-2 uppercase'>Fidelitus Project</h6>
              <h6 data-aos="fade-left"className='w-[50px] border-b-[2px] rounded-[10px] border-[#027d9b]'></h6>
            </div>
                  {/* <h6 data-aos="fade-left" data-aos-delay="300" className='md:w-[90%] font_normal text-[14px] mt-2'>Fidelitus Projects is a leading Design-Build Commercial and industrial infrastructure provider based in Bengaluru. Our team of experienced industry professionals helps you grab every growth development opportunity in Turnkey commercial interior & industrial infrastructure. </h6>
                  <h6 data-aos="fade-left" data-aos-delay="300" className='md:w-[90%] font_normal text-[14px] mt-2'>Also as a leading interior designing firm in Bangalore, we showcase our expertise not just in the fields of Architecture, Design, and 3-D Rendering, but also in Project Management, Quantification, and Budgeting, Procurement, Turnkey Projects.</h6> */}
                  <h6 data-aos="fade-up" className='font_bold mt-2 text-[16px] 2xl:text-[20px]' >Who we are and What do we do?</h6>
                  <h6 data-aos="fade-up" className='font_normal mt-2 text-[14px] 2xl:text-[18px]'>Fidelitus Projects is a Techno commercial organisation catering to Turnkey Commercial/ industrial Infrastructure and end to end MEP requirements to channel partners across India.</h6>

                  <h6 data-aos="fade-up" className='font_bold mt-2 text-[16px] 2xl:text-[20px]'>How we work ?</h6>
                  <h6 data-aos="fade-up" className='font_normal mt-2 text-[14px] 2xl:text-[18px]'>As a close-knit team of over 80 members, we bring together a wealth of industry experience to provide our clients with comprehensive, turnkey solutions. We take pride in ourselves being a one-stop solution platform, addressing all your needs efficiently and effectively.</h6>
          </div>
        </div>

        <div className='w-[100%] px-[5%] md:px-[10%] bg-slate-100 py-[5%] flex flex-col items-start justify-center mx-auto'>
          
            <div className='z-10 mb-[4%] bg-bottom bg-contain bg-no-repeat'>
                  <h6 data-aos="fade-left" className='text-center text-[20px] 2xl:text-[25px] font_bold'>Our Beliefs</h6>
                  <div className='flex items-center justify-center'>
                    <h6 data-aos="fade-right" className='w-[50px] border-b-[2px] rounded-[10px] border-[#027d9b]'></h6>
                    <h6 data-aos="fade-up" data-aos-delay="300" className='text-[10px] 2xl:text-[20px] font_bold text-[#027d9b] mx-2 uppercase'>Why we Stand Out</h6>
                    <h6 data-aos="fade-left"className='w-[50px] border-b-[2px] rounded-[10px] border-[#027d9b]'></h6>
                  </div>
                  <h6 data-aos="fade-right" className='font_normal my-5 text-center text-[14px] 2xl:text-[18px]'>We believe on the procedure process to provide high <span className='font_bold'> performance-driven</span>, culture</h6>
                  
                  <div>
                  <h6 className='text-[14px] font_normal text-center mt-4 2xl:text-[18px]'>We, at Fidelitus believe in a performance-driven culture, where we go to great lengths to deliver each project with perfection. Our team goes beyond the limited professional contract for giving you the output, worth appreciating. Our core belief dictates that client contentment is our top-most priority. Hence, the bonds that we develop with them help us understand them better and deliver nothing but the best.</h6>
                  </div>

            </div>

            <div className='w-[100%] md:w-[100%] md:mt-0 md:gap-4 mx-auto grid grid-cols-2  md:grid-cols-4'>
                {beliefArr?.map((f,i)=>(
                  <div  data-aos="fade-up" className={`p-4 ${(i !== beliefArr?.length - 1) && `md:border-r border-gray-200 md:border-gray-300  ${(i == 0 || i == 2)  && 'border-r'}  ${(i == 0 || i == 1)  && ' border-b md:border-b-0'} ` }`} style={{background:f?.color}}>
                    <div className='flex items-center justify-center'>
                        <img src={f?.img} className='w-[70px] h-[70px] 2xl:w-auto 2xl:h-[120px] object-contain' />
                    </div>
                    <h6 className='font_bold mt-2 2xl:mt-6 text-center text-[14px] md:text-[13.5px] 2xl:text-[20px]'>{f?.value}</h6>
                  </div>  
                ))}
            </div>
        </div>
        <div className='py-10 md:py-[2%] border-b border-slate-100 md:flex items-center justify-center w-[100%] px-[10%] mx-auto'>

            <div  data-aos="fade-right" className='md:w-[40%] relative md:mr-[5%] h-[400px] 2xl:h-auto'>
              <img src={teamArr[0]?.img} alt={teamArr[0]?.img} className='h-full object-cover w-[100%]'  />
              {teamArr[0]?.linked_in_link !== '' && 
              <FaLinkedin onClick={()=>openLinkedin(teamArr[0]?.linked_in_link)} size={28} className='absolute cursor-pointer bg-white/20 p-[5px] z-10 right-[10px] bottom-[10px]' />}
            </div>

            <div className='mt-10 md:mt-0 md:w-[60%]'>
                <h6 data-aos="fade-up" className='font_bold text-[12px] md:text-[14px] 2xl:text-[25px]'>Achuth Gowda</h6>     
                <h6 data-aos="fade-up" className='text-[13px] font_bold  mb-[-5px] 2xl:text-[16px]'>Founder</h6>     
                <h6 data-aos="fade-up" className='text-[13px] font_normal 2xl:text-[18px]  mt-4'>Under his leadership, Fidelitus Corp has grown to become a leader in commercial real estate transactions and a trusted advisory real estate company in Bangalore. His leadership skills since 2013 has led to the companies growth and branch out into many verticals and grow in each one of them. His business acumen has lead the company to develop its core services as well as increase its revenue from other domains. Achuth Gowda is the recipient of the prestigious Nada Prabhu Kempegowda Award 2020.</h6>     
                <h6 data-aos="fade-up" className='text-[13px] font_normal 2xl:text-[18px] mt-4'>A Founder is the first employee of the organization and when they treat even employee as an EMPLOYER those individuals develop a sense of responsibility & belongingness towards the company and the success derived out of such efforts transcends to a whole new level!</h6>     
            </div>    

       
           
        </div>
        <div className='mt-[5%]'>
        <div className='py-10 bg-gray-50'>
      <div className='w-[90%] md:w-[80%] mx-[5%] md:mx-[10%]'>
         <h6 data-aos="fade-right" className='font_bold text-[19px] flex mt-10'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#027d9b]'></span>Leaders of Fidelitus - Our Team</h6>
         <h6 data-aos="fade-right" className='font_normal text-[14px] ml-5 mt-4'>At Fidelitus, we take pride in nurturing and developing our employees' expertise, empowering them to excel in their roles. Our team is our greatest strength — together, we have consistently turned challenges into opportunities and made the impossible possible</h6>
         {/* <h6 data-aos="fade-right" className='font_normal text-[14px] ml-5 mt-4'>We are the leaders of fidelitus who make our employee expertise in their work and train them to expertise in their works! and team is our strength with them we have made impossible things as possible .</h6> */}
         

         <div className='grid grid-cols-2 gap-2 mx-auto md:grid-cols-3 lg:grid-cols-5'>
            {teamArr?.slice(0,8)?.map((t,i)=>(
                <div data-aos="fade-up" key={i} className='relative px-1 pt-1 pb-1 mt-2 transition-all duration-300 bg-white shadow cursor-pointer group'>
                <img alt={'img'} src={t?.img} className='w-[100%] h-[190px]  md:h-[190px] lg:h-[220px] object-cover  duration-300  group-hover:scale-95 bg-[#f4f4f4]' />
                <h6 className='font_normal mt-2 text-[14px]'>{t?.name}</h6>
                <h6 className='font_normal text-[11px]'>{t?.designation}</h6>
                {t?.linked_in !== '' && <CiLinkedin onClick={()=>window.open(t?.linked_in)} size={24} className='absolute cursor-pointer right-5 top-5' />}
                </div>    
            ))}
         </div>
      </div>   
         </div>
        
        {/* <div className='z-10 bg-bottom bg-no-repeat bg-contain'>
          <h6 data-aos="fade-left" className='text-center text-[20px] 2xl:text-[25px]  font_bold'>Our Army</h6>
          <div className='flex items-center justify-center'>
            <h6 data-aos="fade-right" className='w-[50px] border-b-[2px] rounded-[10px] border-[#027d9b]'></h6>
            <h6 data-aos="fade-up" data-aos-delay="300" className='text-[10px] font_bold 2xl:text-[16px]  text-[#027d9b] mx-2'>LET'S CONNECT</h6>
            <h6 data-aos="fade-left"className='w-[50px] border-b-[2px] rounded-[10px]  border-[#027d9b]'></h6>
          </div>
          </div>

          <div className="grid z-20 grid-cols-2 md:grid-cols-5 my-[5%] gap-5 w-[80%] mx-auto">
  {teamArr?.slice(8).map((t, i) => (
    <div data-aos="fade-up" key={i} className="relative w-full">

      {t?.linked_in_link && (
        <FaLinkedin
          onClick={() => openLinkedin(t?.linked_in_link)}
          size={24}
          className="absolute z-10 cursor-pointer bg-white/80 p-[5px] right-[10px] bottom-[10px] rounded"
        />
      )}

      <img
        src={t?.img}
        alt={t?.name}
        className="h-[200px] md:h-[250px] 2xl:h-[420px] object-cover w-full"
      />

      <div className="absolute bottom-2 bg-white/40 backdrop-blur-md p-2 w-[90%] mx-[5%]">
        <h6 className="font_bold text-[12px] md:text-[14px] 2xl:text-[20px]">
          {t?.name}
        </h6>
        <h6 className="text-[11px] md:text-[13px] font_normal 2xl:text-[16px]">
          {t?.designation}
        </h6>
      </div>
    </div>
  ))}
</div> */}

        </div>
        <div className='bg-slate-100 relative min-h-[200px] mt-[12%] p-10 px-[10%]'>  
        <div className='w-[70%] md:w-[40%]'>
          <h6 className='font_bold text-[18px] w-[80%] 2xl:text-[24px]'>Experience Team to Support our Customer</h6>
          <h6 className='font_normal text-[14px] w-[100%] z-40 2xl:text-[18px]'>We are ready to assist you, For any query related about our services please give us a call!</h6>
          <Link to={`tel:${mobile}`} target='_blank'>
          <h6  data-aos="fade-left" data-aos-delay="600" className='font_bold z-10 text-[12px] 2xl:text-[15px] border mt-2 w-[100px] text-center p-[5px] border-black hover:bg-black hover:text-white cursor-pointer duration-300'>Contact Us</h6>
          </Link>
        </div>
        {/* <img src={call1Img} className='h-[280px] 2xl:h-[400px] bottom-[0px] absolute z-[0] right-[-10%] md:right-[10%] mix-blend-multiply;' /> */}
        </div>
      </div>
  )
}

export default About


